import { ReactElement, useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { Stack } from '@mui/material'
import { useSnackbar } from '@ui/snackbar'
import ConnectionPrioritizationList from 'src/components/manager/connections/ConnectionPrioritizationList'
import { schema } from '../schema'

interface Props {
  connections: Array<Connection | ProjectConnection>
  onSave: (values: ProjectConnectionPrioritization) => void
}

const ProjectConnectionPrioritizationLists = ({ connections, onSave }: Props): ReactElement => {
  const { getValues } = useFormContext()
  const { enqueueSnackbar } = useSnackbar()

  const handleChange = useCallback(() => {
    const values = getValues() as ProjectConnectionPrioritization
    schema
      .isValid(values)
      .then(isValid => {
        if (!isValid) {
          enqueueSnackbar('Bitte wählen Sie für jedes Szenario mindestens eine Zugverbindung', {
            variant: 'error',
          })
          return
        }
        onSave(values)
      })
      .catch(() => {
        enqueueSnackbar('Bitte wählen Sie für jedes Szenario mindestens eine Zugverbindung', {
          variant: 'error',
        })
      })
  }, [enqueueSnackbar, getValues, onSave])

  return (
    <Stack spacing={3}>
      <ConnectionPrioritizationList
        fieldName="inner_inner"
        title="Innen-Innen"
        availableConnections={connections}
        data-cy="inner"
        onChange={handleChange}
      />
      <ConnectionPrioritizationList
        fieldName="inner_foundation"
        title="Innen-Fundament"
        availableConnections={connections}
        data-cy="inner-foundation"
        onChange={handleChange}
      />
      <ConnectionPrioritizationList
        fieldName="outer_outer"
        title="Außen-Außen"
        availableConnections={connections}
        data-cy="outer"
        onChange={handleChange}
      />
      <ConnectionPrioritizationList
        fieldName="outer_foundation"
        title="Außen-Fundament"
        availableConnections={connections}
        data-cy="outer-foundation"
        onChange={handleChange}
      />
    </Stack>
  )
}

export default ProjectConnectionPrioritizationLists
